function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownCheckboxOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.335 161.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 151.411,
    height: 151.411,
    x: 87.988,
    y: 69.702,
    ry: 12.603,
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "var(--stroke-contrast-mid)",
      strokeWidth: 9.924,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-83.026 -64.74)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownCheckboxOff);
export default __webpack_public_path__ + "static/media/drop-down-checkbox-off.2fadc2bd837a6954723f0bced926d8be.svg";
export { ForwardRef as ReactComponent };